export default __webpack_public_path__ + "static/media/eos.9c0e174c.png";